import React, { useEffect, useState } from "react";
import { fb, instagram, telegram, whatsapp } from "../../assets/img";
import { toast } from "react-toastify";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import Loader from "../../Component/Loader";
import { Toast } from "../../Component/Toast";
import useStore from "../../LocalStore/useStore";

const Links = () => {
  const [loading, setLoading] = useState(false);
  const { kv, set } = useStore();
  let link_obj = kv.link_obj || {
    whatspp: "",
    facebook: "",
    telegram: "",
    instagram: "",
    whatspp_group: "",
  };
  const [formData, setFormData] = useState(
    link_obj ?? {
      whatspp: "",
      facebook: "",
      telegram: "",
      instagram: "",
      whatspp_group: "",
    },
  );

  const getList = async () => {
    try {
      let val_load = Object.values(link_obj).some((val) => val == "");
      // if (val_load) {
      //   setLoading(true);
      // }
      const res = await get(`${URLS.USER}&type=5`);
      // // console.log("Fetched data:", res);

      if (res?.status === "success" && res?.data) {
        setFormData({
          whatspp: res.data.whatspp || "",
          facebook: res.data.facebook || "",
          telegram: res.data.telegram || "",
          instagram: res.data.instagram || "",
          whatspp_group: res.data.whatspp_group || "",
        });
        set("link_obj", {
          whatspp: res.data.whatspp || "",
          facebook: res.data.facebook || "",
          telegram: res.data.telegram || "",
          instagram: res.data.instagram || "",
          whatspp_group: res.data.whatspp_group || "",
        });
        setLoading(false);
      }
    } catch (err) {
      Toast("Failed to load links");
      console.error(err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <div className="dashRightView-foot">
      {formData?.whatspp && (
        <>
          <div className="d-flex ac-js gap-1">
            <img src={whatsapp} width={30} height={30} alt="" />
            <p className="f3 fs-xs-14 fs-sm-18 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 gray">
              WhatsApp
            </p>
          </div>
          <div className="input-box-link mt-2 mb-4">
            <a
              style={{
                color: "#000000ff", // fixed typo from 'lightgray'
                fontSize: 14,
                display: "inline-block",
                maxWidth: "100%", // or set a fixed width like '250px'
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                verticalAlign: "bottom",
              }}
              href={formData?.whatspp}
              target={"_blank"}
            >
              {formData?.whatspp}
            </a>
          </div>
        </>
      )}
      {formData?.whatspp_group && (
        <>
          <div className="d-flex ac-js gap-1">
            <img src={whatsapp} width={30} height={30} alt="" />
            <p className="f3  fs-xs-14 fs-sm-18 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 gray">
              WhatsApp Group
            </p>
          </div>
          <div className="input-box-link mt-2 mb-4">
            <a
              style={{
                color: "#000000ff", // fixed typo from 'lightgray'
                fontSize: 14,
                display: "inline-block",
                maxWidth: "100%", // or set a fixed width like '250px'
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                verticalAlign: "bottom",
              }}
              href={formData?.whatspp_group}
              target={"_blank"}
            >
              {formData?.whatspp_group}
            </a>
          </div>
        </>
      )}
      {formData?.telegram && (
        <>
          <div className="d-flex ac-js gap-1">
            <img src={telegram} width={30} height={30} alt="" />
            <p className="f3 fs-xs-14 fs-sm-18 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 gray">
              Telegram
            </p>
          </div>
          <div className="input-box-link mt-2 mb-4">
            <a
              style={{
                color: "#000000ff", // fixed typo from 'lightgray'
                fontSize: 14,
                display: "inline-block",
                maxWidth: "100%", // or set a fixed width like '250px'
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                verticalAlign: "bottom",
              }}
              href={formData?.telegram}
              target={"_blank"}
            >
              {formData?.telegram}
            </a>
          </div>
        </>
      )}
      {formData?.instagram && (
        <>
          <div className="d-flex ac-js gap-1">
            <img src={instagram} width={30} height={30} alt="" />
            <p className="f3 fs-xs-14 fs-sm-18 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 gray">
              Instagram
            </p>
          </div>
          <div className="input-box-link mt-2 mb-4">
            <a
              style={{
                color: "#000000ff", // fixed typo from 'lightgray'
                fontSize: 14,
                display: "inline-block",
                maxWidth: "100%", // or set a fixed width like '250px'
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                verticalAlign: "bottom",
              }}
              href={formData?.instagram}
              target={"_blank"}
            >
              {formData?.instagram}
            </a>
          </div>
        </>
      )}

      {formData?.facebook && (
        <>
          <div className="d-flex ac-js gap-1">
            <img src={fb} width={30} height={30} alt="" />
            <p className="f3 fs-xs-14 fs-sm-18 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 gray">
              Facebook
            </p>
          </div>
          <div className="input-box-link mt-2 mb-4">
            <a
              style={{
                color: "#000000ff", // fixed typo from 'lightgray'
                fontSize: 14,
                display: "inline-block",
                maxWidth: "100%", // or set a fixed width like '250px'
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                verticalAlign: "bottom",
              }}
              href={formData?.facebook}
              target={"_blank"}
            >
              {formData?.facebook}
            </a>
          </div>
        </>
      )}
      {!formData?.whatspp &&
        !formData?.whatspp_group &&
        !formData?.telegram &&
        !formData?.instagram &&
        !formData?.facebook && (
          <div className="no-data-found d-flex ac-jc flex-column">
            <p className="f3 mt-2">No Data</p>
          </div>
        )}
      {loading && <Loader />}
    </div>
  );
};

export default Links;
